import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"วีซ่าธุรกิจไทย Non-Immigrant B — Business Visa","metaTitle":"วีซ่าธุรกิจไทย Non-B — BOI, บริษัทจำกัด, IEAT | NYC","metaDesc":"วีซ่าธุรกิจไทย Non-Immigrant B ยื่นแทนบริษัท เตรียมเอกสาร BOI/บริษัท 90-วัน ต่อวีซ่า 1 ปี Reentry Permit ครบ — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"Thai Business Visa Non-Immigrant B — Work & Investment","metaTitle":"Thai Non-B Business Visa — BOI, Ltd, IEAT, Extensions | NYC","metaDesc":"Thai Non-B visa filing for companies and BOI. 90-day and 1-year extensions, Re-entry Permit and Work — Talk to a specialist today; no obligation, fast reply."}} as const;

export const Route = createFileRoute("/en/visa/business")({
  head: () => {
    const url = `${SEO_SITE}/en/visa.business`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/visa/business", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/visa/business", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/visa/business", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/visa/business", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/visa.business", "/en/visa.business")],
    };
  },
  component: () => <SubServicePage slug="visa/business" locale="en" />,
});
